<template>
  <ul class="actions items cul">
    <li id="search" class="item" tabindex="-1">
      <HeaderActionSearch />
    </li>
    <li class="item">
      <HeaderActionCart />
    </li>
    <li class="item">
      <HeaderActionProfile />
    </li>
    <li class="item">
      <HeaderActionMobileMenuToggle />
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  translate: calc((var(--button-action-width) - 24px) / 2);
}

#search :focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
  border-radius: 3px;
}
</style>
